(function () {
  var root = document.querySelector('[data-sound-library]');
  if (!root) return;

  var ALL_ROWS = Array.prototype.slice.call(root.querySelectorAll('[data-sl-row]'));
  var vignettes = Array.prototype.slice.call(root.querySelectorAll('[data-sl-vignette]'));
  var playerArea = root.querySelector('[data-sl-player-area]');
  var emptyEl = root.querySelector('[data-sl-empty]');
  var playerEl = root.querySelector('[data-sl-player]');
  var nameEl = root.querySelector('[data-sl-active-name]');
  var metaEl = root.querySelector('[data-sl-active-meta]');
  var noMatchEl = root.querySelector('[data-sl-no-match]');

  var IS_FR_LANG = (document.documentElement.lang || 'fr').toLowerCase().indexOf('fr') === 0;
  var I18N_RECORDINGS = IS_FR_LANG ? 'enregistrements' : 'recordings';
  var I18N_RECORDING = IS_FR_LANG ? 'enregistrement' : 'recording';

  function fmt(t) {
    if (!isFinite(t)) return '0:00';
    var m = Math.floor(t / 60);
    var s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' + s : s);
  }

  /* ---- Helpers ---- */
  function rowAudio(row) {
    if (row.classList.contains('scart-sl__row--valves')) {
      var av = row.querySelector('.scart-sl__valve.is-active');
      var v = av ? av.dataset.slValve : 'closed';
      return row.querySelector('audio[data-valve="' + v + '"]');
    }
    return row.querySelector('audio');
  }
  /* Blob cache : pre-fetched at play time so that the share button can call
     navigator.share({files}) synchronously - required by Chrome Android's
     transient user activation rules. iOS Safari benefits too. */
  var blobCache = {};
  function prefetchBlob(src) {
    if (!src || blobCache[src]) return;
    blobCache[src] = 'pending';
    fetch(src).then(function (r) {
      if (!r.ok) throw new Error('fetch failed');
      return r.blob();
    }).then(function (blob) {
      blobCache[src] = blob;
    }).catch(function () {
      delete blobCache[src];
    });
  }
  function rowAllAudios(row) { return Array.prototype.slice.call(row.querySelectorAll('audio')); }
  function pauseAllExcept(except) {
    ALL_ROWS.forEach(function (r) {
      rowAllAudios(r).forEach(function (a) { if (a !== except && !a.paused) a.pause(); });
    });
  }
  function fadePause(audio, ms) {
    if (!audio || audio.paused) return;
    ms = ms || 800;
    if (audio._fading) return;
    audio._fading = true;
    var startVol = audio.volume;
    var t0 = performance.now();
    function step() {
      if (audio.paused) { audio._fading = false; audio.volume = startVol; return; }
      var elapsed = performance.now() - t0;
      var t = Math.min(elapsed / ms, 1);
      try { audio.volume = Math.max(0, startVol * (1 - t)); } catch (e) {}
      if (t < 1) requestAnimationFrame(step);
      else { audio.pause(); audio.volume = startVol; audio._fading = false; }
    }
    requestAnimationFrame(step);
  }

  /* ---- Best-of rows : recuperer data-gen depuis la row jumelle de la liste principale
     (le bloc "Les plus ecoutes" est rendu sans gen en Liquid pour eviter un hardcode) ---- */
  ALL_ROWS.forEach(function (r) {
    if (!r.dataset.slBestof || r.dataset.gen) return;
    var twin = ALL_ROWS.find(function (o) { return !o.dataset.slBestof && o.dataset.handle === r.dataset.handle; });
    if (twin) r.dataset.gen = twin.dataset.gen;
  });

  /* ---- Count clips per gen + hide empty vignettes (best-of rows exclues : doublons) ---- */
  var countByGen = {};
  ALL_ROWS.forEach(function (r) {
    if (r.dataset.slBestof) return;
    var g = r.dataset.gen;
    countByGen[g] = (countByGen[g] || 0) + 1;
  });
  vignettes.forEach(function (v) {
    var g = v.dataset.slVignette;
    var n = countByGen[g] || 0;
    var countEl = v.querySelector('[data-sl-count-for]');
    if (countEl) countEl.textContent = n > 0 ? (n + ' clips') : '';
    if (n > 0) { v.hidden = false; }
  });

  /* ---- Bandeau configurateur : apres 3 ecoutes sans clic produit ---- */
  var playsSinceClick = 0;
  var configBannerShown = false;
  function showConfigBanner(gen) {
    configBannerShown = true;
    var rows = root.querySelector('[data-sl-rows]');
    if (!rows || root.querySelector('.scart-sl__config-banner')) return;
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var href = rootPath + 'pages/configurateur?cfg_from=sound_library' + (gen ? '&collection=' + encodeURIComponent(gen) : '');
    var el = document.createElement('div');
    el.className = 'scart-sl__config-banner';
    var span = document.createElement('span');
    span.textContent = IS_FR_LANG ? 'Vous hésitez entre les gammes ?' : 'Not sure which range is for you?';
    var a = document.createElement('a');
    a.href = href;
    a.textContent = IS_FR_LANG ? 'Aidez-moi à choisir →' : 'Help me choose →';
    a.addEventListener('click', function () {
      if (window.gtag) window.gtag('event', 'sound_library_config_banner_click', { gen: gen || '' });
    });
    el.appendChild(span);
    el.appendChild(a);
    rows.parentNode.insertBefore(el, rows);
  }
  function notePlay(row) {
    playsSinceClick++;
    if (playsSinceClick >= 3 && !configBannerShown) showConfigBanner(row.dataset.gen || '');
  }

  /* ---- Player wiring ---- */
  var AUTOPLAY_DELAY = 1500;
  function findNextVisibleRow(currentRow) {
    var idx = ALL_ROWS.indexOf(currentRow);
    if (idx === -1) return null;
    for (var i = idx + 1; i < ALL_ROWS.length; i++) {
      var r = ALL_ROWS[i];
      if (r.hidden || r.classList.contains('is-filter-hidden')) continue;
      return r;
    }
    return null;
  }

  ALL_ROWS.forEach(function (row) {
    var playBtn = row.querySelector('.scart-sl__play');
    var thumb = row.querySelector('.scart-sl__progress-thumb');
    var timeEl = row.querySelector('[data-sl-time]');
    var progress = row.querySelector('[data-sl-progress]');
    var audios = rowAllAudios(row);
    var rafId = null;
    var intervalId = null;

    function updateTime(audio) {
      var d = audio.duration || 0;
      var c = audio.currentTime || 0;
      if (timeEl) timeEl.textContent = fmt(c) + ' / ' + fmt(d);
      if (progress && d > 0 && isFinite(d)) {
        var pct = Math.max(0, Math.min(100, (c / d) * 100));
        progress.style.setProperty('--sl-progress', pct + '%');
      }
    }
    function startTick(audio) {
      cancelAnimationFrame(rafId); clearInterval(intervalId);
      function tick() {
        updateTime(audio);
        if (!audio.paused && !audio.ended) rafId = requestAnimationFrame(tick);
      }
      rafId = requestAnimationFrame(tick);
      intervalId = setInterval(function () {
        if (audio.paused || audio.ended) { clearInterval(intervalId); return; }
        updateTime(audio);
      }, 200);
    }
    function stopTick() { cancelAnimationFrame(rafId); clearInterval(intervalId); }

    audios.forEach(function (audio) {
      audio.addEventListener('play', function () {
        row.classList.add('is-playing');
        row.classList.remove('is-shared-clip', 'is-await-tap');
        startTick(audio);
        if (window.gtag) window.gtag('event', 'sound_library_play', {
          handle: row.dataset.handle,
          range: row.dataset.range,
          placement: row.dataset.slBestof ? 'bestof' : 'list'
        });
        notePlay(row);
      });
      audio.addEventListener('pause', function () {
        stopTick();
        var anyPlaying = audios.some(function (a) { return !a.paused; });
        if (!anyPlaying) row.classList.remove('is-playing');
        updateTime(audio);
      });
      audio.addEventListener('ended', function () {
        stopTick();
        row.classList.remove('is-playing');
        if (progress) progress.style.setProperty('--sl-progress', '0%');
        if (timeEl) timeEl.textContent = '0:00 / ' + fmt(audio.duration || 0);
        var next = findNextVisibleRow(row);
        if (next && !document.hidden) {
          setTimeout(function () {
            if (document.hidden) return;
            var btn = next.querySelector('.scart-sl__play');
            if (btn) {
              next.scrollIntoView({ behavior: 'smooth', block: 'center' });
              btn.click();
            }
          }, AUTOPLAY_DELAY);
        }
      });
      audio.addEventListener('timeupdate', function () {
        updateTime(audio);
        /* Ecoute reelle : 75% du clip atteint, une fois par clip par page */
        if (!audio._s75 && audio.duration && audio.currentTime / audio.duration >= 0.75) {
          audio._s75 = true;
          if (window.gtag) window.gtag('event', 'sound_library_listen_75', {
            handle: row.dataset.handle,
            range: row.dataset.range,
            placement: row.dataset.slBestof ? 'bestof' : 'list'
          });
        }
      });
      audio.addEventListener('loadedmetadata', function () { updateTime(audio); });
      audio.addEventListener('durationchange', function () { updateTime(audio); });
    });

    function togglePlay() {
      var audio = rowAudio(row);
      if (!audio) return;
      if (audio.paused) {
        pauseAllExcept(audio);
        prefetchBlob(audio.src);
        audio.play().catch(function () {});
      } else {
        audio.pause();
      }
    }
    if (playBtn) playBtn.addEventListener('click', function (e) { e.stopPropagation(); togglePlay(); });

    var EXCLUDE = '.scart-sl__progress, .scart-sl__product, .scart-sl__cta, .scart-sl__yt, .scart-sl__ig, .scart-sl__local, .scart-sl__valves-switch, .scart-sl__valve, .scart-sl__play, .scart-sl__share';
    row.addEventListener('click', function (e) {
      if (e.target.closest(EXCLUDE)) return;
      togglePlay();
    });

    /* Progress seek */
    if (progress) {
      var dragging = false;
      function seek(e) {
        var audio = rowAudio(row);
        if (!audio || !audio.duration) return;
        var rect = progress.getBoundingClientRect();
        var x = (e.clientX != null ? e.clientX : (e.touches && e.touches[0] ? e.touches[0].clientX : 0));
        var pct = Math.max(0, Math.min(1, (x - rect.left) / rect.width));
        audio.currentTime = audio.duration * pct;
        progress.style.setProperty('--sl-progress', (pct * 100) + '%');
      }
      progress.addEventListener('pointerdown', function (e) {
        dragging = true;
        progress.setPointerCapture && progress.setPointerCapture(e.pointerId);
        seek(e);
      });
      progress.addEventListener('pointermove', function (e) { if (dragging) seek(e); });
      progress.addEventListener('pointerup', function () { dragging = false; });
      progress.addEventListener('pointercancel', function () { dragging = false; });
    }

    /* Valves switch */
    var valveBtns = row.querySelectorAll('[data-sl-valve]');
    valveBtns.forEach(function (vb) {
      vb.addEventListener('click', function (e) {
        e.stopPropagation();
        var v = vb.dataset.slValve;
        valveBtns.forEach(function (b) { b.classList.toggle('is-active', b === vb); });
        var wasPlaying = audios.some(function (a) { return !a.paused; });
        var prevTime = 0;
        audios.forEach(function (a) { if (!a.paused) { prevTime = a.currentTime; a.pause(); } });
        if (wasPlaying) {
          var target = row.querySelector('audio[data-valve="' + v + '"]');
          if (target) {
            pauseAllExcept(target);
            try { target.currentTime = Math.min(prevTime, target.duration || prevTime); } catch (e2) {}
            target.play().catch(function () {});
          }
        }
        if (window.gtag) window.gtag('event', 'sound_library_valve_switch', { handle: row.dataset.handle, valve: v });
      });
    });
  });

  /* ---- Vignette selection (Step 01 → Step 02) ---- */
  var currentGen = null;
  var currentGenPeriod = '';
  var rangeFilter = new Set();
  var searchTerm = '';

  function applyFilters() {
    if (!currentGen) return;
    var visibleCount = 0;
    var totalForGen = 0;
    ALL_ROWS.forEach(function (row) {
      if (row.dataset.slBestof) return; /* le bloc best-of reste visible quel que soit le filtre */
      if (row.dataset.gen !== currentGen) {
        row.hidden = true;
        row.classList.remove('is-filter-hidden');
        return;
      }
      row.hidden = false;
      totalForGen++;
      var range = row.dataset.range;
      var blob = row.dataset.search || '';
      var matchRange = rangeFilter.size === 0 || rangeFilter.has(range);
      var matchSearch = !searchTerm || blob.indexOf(searchTerm) !== -1;
      var show = matchRange && matchSearch;
      row.classList.toggle('is-filter-hidden', !show);
      if (show) visibleCount++;
    });
    if (metaEl) {
      var countText;
      if (rangeFilter.size === 0 && !searchTerm) {
        countText = totalForGen + ' ' + (totalForGen === 1 ? I18N_RECORDING : I18N_RECORDINGS);
      } else {
        countText = visibleCount + ' / ' + totalForGen + ' ' + I18N_RECORDINGS;
      }
      metaEl.textContent = currentGenPeriod ? currentGenPeriod + '  ·  ' + countText : countText;
    }
    if (noMatchEl) noMatchEl.hidden = visibleCount !== 0;
  }

  var stickyImg = root.querySelector('[data-sl-sticky-img]');
  var vignettesArea = root.querySelector('[data-sl-vignettes]');

  function selectGen(genHandle, genName, genPeriod) {
    if (currentGen === genHandle) {
      /* Deselect */
      currentGen = null;
      vignettes.forEach(function (v) { v.classList.remove('is-active'); });
      ALL_ROWS.forEach(function (r) { if (r.dataset.slBestof) return; r.hidden = true; r.classList.remove('is-filter-hidden'); });
      pauseAllExcept(null);
      if (playerEl) playerEl.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    /* Stop any playing audio */
    pauseAllExcept(null);
    currentGen = genHandle;
    vignettes.forEach(function (v) { v.classList.toggle('is-active', v.dataset.slVignette === genHandle); });
    if (nameEl) nameEl.textContent = genName;
    if (emptyEl) emptyEl.hidden = true;
    /* Set sticky thumb from the clicked vignette */
    var activeVignette = root.querySelector('[data-sl-vignette="' + genHandle + '"]');
    if (activeVignette && stickyImg) {
      var srcImg = activeVignette.querySelector('img');
      if (srcImg) stickyImg.src = srcImg.src;
    }
    if (playerEl) {
      playerEl.hidden = false;
      /* Re-trigger reveal animation */
      playerEl.style.animation = 'none';
      void playerEl.offsetWidth;
      playerEl.style.animation = '';
    }
    currentGenPeriod = genPeriod || '';
    applyFilters();
    if (window.gtag) window.gtag('event', 'sound_library_select_gen', { gen: genHandle });
    /* Smooth scroll to player area */
    setTimeout(function () {
      if (playerArea) playerArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
  }

  /* "Changer" button in sticky → scroll back to vignettes grid */
  var changeBtn = root.querySelector('[data-sl-change-car]');
  if (changeBtn) {
    changeBtn.addEventListener('click', function () {
      if (vignettesArea) vignettesArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (window.gtag) window.gtag('event', 'sound_library_change_car', { from_gen: currentGen });
    });
  }

  /* Track product link clicks (→ PDP) and return-link clicks */
  root.querySelectorAll('.scart-sl__product').forEach(function (link) {
    link.addEventListener('click', function () {
      playsSinceClick = 0;
      var row = link.closest('[data-sl-row]');
      if (window.gtag) window.gtag('event', 'sound_library_to_pdp', {
        handle: row ? row.dataset.handle : null,
        range: row ? row.dataset.range : null,
        gen: row ? row.dataset.gen : null
      });
    });
  });
  /* CTA prix "Voir cette pièce" (visible en lecture) */
  root.querySelectorAll('.scart-sl__cta').forEach(function (link) {
    link.addEventListener('click', function () {
      playsSinceClick = 0;
      var row = link.closest('[data-sl-row]');
      if (window.gtag) window.gtag('event', 'sound_library_to_pdp', {
        handle: row ? row.dataset.handle : null,
        range: row ? row.dataset.range : null,
        gen: row ? row.dataset.gen : null,
        cta: 'price_button'
      });
    });
  });
  var returnLink = document.querySelector('[data-sl-return]');
  if (returnLink) {
    returnLink.addEventListener('click', function () {
      if (window.gtag) window.gtag('event', 'sound_library_return_click', {
        destination: returnLink.getAttribute('href')
      });
    });
  }

  vignettes.forEach(function (v) {
    v.addEventListener('click', function () {
      selectGen(v.dataset.slVignette, v.dataset.slVignetteName, v.dataset.slVignettePeriod);
    });
  });

  /* ---- Filters ---- */
  var rangeChips = root.querySelectorAll('[data-sl-range-chip]');
  var searchInput = root.querySelector('[data-sl-search]');

  rangeChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var v = chip.dataset.slRangeChip;
      if (rangeFilter.has(v)) { rangeFilter.delete(v); chip.classList.remove('is-active'); }
      else { rangeFilter.add(v); chip.classList.add('is-active'); }
      applyFilters();
      if (window.gtag) window.gtag('event', 'sound_library_filter', { type: 'range', value: v });
    });
  });

  if (searchInput) {
    var searchTimer;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        searchTerm = (searchInput.value || '').toLowerCase().trim();
        applyFilters();
      }, 120);
    });
  }

  var resetBtn = root.querySelector('[data-sl-reset]');
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      rangeFilter.clear();
      searchTerm = '';
      if (searchInput) searchInput.value = '';
      rangeChips.forEach(function (c) { c.classList.remove('is-active'); });
      applyFilters();
    });
  }

  /* ---- Source Modal (YT iframe ou vidéo Shopify native) ---- */
  var ytmodal = root.querySelector('[data-sl-ytmodal]');
  var ytiframe = root.querySelector('[data-sl-ytiframe]');
  var nativeVideo = root.querySelector('[data-sl-igvideo]');

  function openYT(videoId, startSec) {
    if (!ytmodal || !ytiframe || !videoId) return;
    var url = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
    if (startSec) url += '&start=' + Math.floor(startSec);
    if (nativeVideo) { nativeVideo.pause(); nativeVideo.removeAttribute('src'); nativeVideo.load(); nativeVideo.hidden = true; }
    ytiframe.hidden = false;
    ytiframe.src = url;
    ytmodal.hidden = false;
    pauseAllExcept(null);
    document.body.style.overflow = 'hidden';
    if (window.gtag) window.gtag('event', 'sound_library_yt_open', { video_id: videoId });
  }
  function openNativeVideo(videoUrl, startSec, sourceType, sourceRef) {
    if (!ytmodal || !nativeVideo || !videoUrl) return;
    if (ytiframe) { ytiframe.src = ''; ytiframe.hidden = true; }
    nativeVideo.hidden = false;
    nativeVideo.addEventListener('loadedmetadata', function () {
      if (startSec) {
        try { nativeVideo.currentTime = Math.min(Number(startSec), nativeVideo.duration || Number(startSec)); } catch (e) {}
      }
      nativeVideo.play().catch(function() { /* autoplay blocked, user can click play */ });
    }, { once: true });
    nativeVideo.src = videoUrl;
    nativeVideo.load();
    ytmodal.hidden = false;
    pauseAllExcept(null);
    document.body.style.overflow = 'hidden';
    if (window.gtag) window.gtag('event', 'sound_library_video_open', {
      source: sourceType || 'shopify',
      source_ref: sourceRef || ''
    });
  }
  function closeYT() {
    if (!ytmodal) return;
    if (ytiframe) ytiframe.src = '';
    if (nativeVideo) { nativeVideo.pause(); nativeVideo.removeAttribute('src'); nativeVideo.load(); }
    ytmodal.hidden = true;
    document.body.style.overflow = '';
  }
  root.querySelectorAll('[data-sl-yt]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var row = btn.closest('[data-sl-row]');
      var videoId, startSec;
      if (row && row.classList.contains('scart-sl__row--valves')) {
        var active = row.querySelector('.scart-sl__valve.is-active');
        var v = active ? active.dataset.slValve : 'closed';
        videoId = btn.dataset['ytId' + v.charAt(0).toUpperCase() + v.slice(1)];
        startSec = btn.dataset['ytStart' + v.charAt(0).toUpperCase() + v.slice(1)];
      } else {
        videoId = btn.dataset.ytId;
        startSec = btn.dataset.ytStart;
      }
      openYT(videoId, startSec);
    });
  });
  root.querySelectorAll('[data-sl-ig-video]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var url = btn.dataset.igVideoUrl;
      var shortcode = btn.dataset.igUrl ? btn.dataset.igUrl.replace(/.*\/reel\/([^/]+).*/, '$1') : '';
      openNativeVideo(url, 0, 'instagram', shortcode);
    });
  });
  root.querySelectorAll('[data-sl-local-video]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var row = btn.closest('[data-sl-row]');
      var url = btn.dataset.localVideoUrl;
      var startSec = btn.dataset.localVideoStart;
      if (row && row.classList.contains('scart-sl__row--valves')) {
        var active = row.querySelector('.scart-sl__valve.is-active');
        var valve = active ? active.dataset.slValve : 'closed';
        var suffix = valve.charAt(0).toUpperCase() + valve.slice(1);
        url = btn.dataset['localVideoUrl' + suffix];
        startSec = btn.dataset['localVideoStart' + suffix];
      }
      openNativeVideo(url, startSec, 'local', btn.dataset.localId || '');
    });
  });
  root.querySelectorAll('[data-sl-ytclose]').forEach(function (el) {
    el.addEventListener('click', closeYT);
  });
  if (ytmodal) {
    ytmodal.addEventListener('click', function (e) {
      if (e.target.tagName === 'IFRAME' || e.target.tagName === 'VIDEO') return;
      if (e.target.closest('.scart-sl__ytmodal-frame')) return;
      closeYT();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ytmodal && !ytmodal.hidden) closeYT();
  });

  /* ---- Pause on tab/window hidden ---- */
  document.addEventListener('visibilitychange', function () { if (document.hidden) pauseAllExcept(null); });
  window.addEventListener('blur', function () { pauseAllExcept(null); });
  window.addEventListener('pagehide', function () { pauseAllExcept(null); });

  /* ---- Browser detection (utilise par share + debug) ----
     Chrome Android (>=121 environ) refuse navigator.share({files: [m4a]}) avec NotAllowedError
     "Permission denied" alors meme que canShare({files}) retourne true (bug/restriction MIME
     runtime, audio/mp4 dans une blacklist interne). Pire : ce premier rejet consomme l'activation
     utilisateur, donc tout fallback URL share echoue aussi avec "Must be handling a user gesture".
     Sur iOS Safari le file share marche bien. Solution : skip file share sur Chrome Android,
     garder file share sur iOS et autres browsers compatibles. */
  var UA = navigator.userAgent || '';
  var IS_CHROME_ANDROID = /Android/i.test(UA) && /Chrome\//i.test(UA);

  /* ---- Share button (Web Share API + clipboard fallback) ---- */
  var toastEl = null;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'scart-sl__toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._timer);
    toastEl._timer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2200);
  }
  function buildShareUrl(row) {
    var gen = row.dataset.gen || '';
    var handle = row.dataset.handle || '';
    var origin = window.location.origin;
    var url = origin + '/pages/sound-library';
    var params = [];
    if (gen) params.push('gen=' + encodeURIComponent(gen));
    if (handle) params.push('clip=' + encodeURIComponent(handle));
    if (params.length) url += '?' + params.join('&');
    return url;
  }
  function shareRow(row) {
    var url = buildShareUrl(row);
    var modelEl = row.querySelector('.scart-sl__model');
    var rangeEl = row.querySelector('.scart-sl__rangetag');
    var sceneEl = row.querySelector('.scart-sl__scene');
    var titleBits = [];
    if (modelEl) titleBits.push(modelEl.textContent.trim());
    if (rangeEl) titleBits.push(rangeEl.textContent.trim());
    var title = 'Scart' + (titleBits.length ? ' - ' + titleBits.join(' - ') : '');
    var text = IS_FR ? "Écoute ce son d'échappement Scart" : 'Listen to this Scart exhaust sound';
    if (sceneEl) text += ' (' + sceneEl.textContent.trim() + ')';
    /* Note : ne pas concaténer `url` dans `text` — les apps de partage liraient `text` ET `url`,
       affichant le lien en double dans le message. Le Web Share API combine les deux proprement. */
    var audio = rowAudio(row);
    var audioSrc = audio ? audio.src : null;
    var handle = row.dataset.handle || '';

    function gaTrack(method) {
      if (window.gtag) window.gtag('event', 'sound_library_share', {
        handle: handle, range: row.dataset.range, method: method
      });
    }

    function copyToClipboard() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          showToast(IS_FR ? 'Lien copié' : 'Link copied');
          gaTrack('clipboard');
        }).catch(function () {
          showToast(url);
          gaTrack('clipboard_failed');
        });
      } else {
        showToast(url);
        gaTrack('display');
      }
    }

    function isUserCancel(err) {
      return err && (err.name === 'AbortError' || /cancel/i.test(err.message || ''));
    }

    function shareUrlOnly() {
      if (typeof navigator.share === 'function') {
        try {
          navigator.share({ title: title, text: text, url: url })
            .then(function () { gaTrack('native_url'); })
            .catch(function (err) {
              if (!isUserCancel(err)) copyToClipboard();
            });
        } catch (e) {
          copyToClipboard();
        }
      } else {
        copyToClipboard();
      }
    }

    /* File share (.m4a directly) via blob pre-fetched au play. iOS Safari supporte cela
       proprement : le destinataire recoit le m4a inline dans WhatsApp/Messages/Signal.
       Chrome Android skip cette branche (cf. commentaire IS_CHROME_ANDROID en haut) : on
       passe direct au URL share pour preserver l'activation utilisateur et garantir l'ouverture
       de la modale partage system. */
    var cachedBlob = audioSrc && blobCache[audioSrc];
    if (!IS_CHROME_ANDROID
        && cachedBlob && cachedBlob !== 'pending'
        && typeof navigator.share === 'function'
        && typeof navigator.canShare === 'function') {
      var filename = handle ? ('scart-' + handle.slice(0, 40) + '.m4a') : 'scart-sound.m4a';
      var file = new File([cachedBlob], filename, { type: cachedBlob.type || 'audio/mp4' });
      if (navigator.canShare({ files: [file] })) {
        try {
          navigator.share({ title: title, text: text, files: [file] })
            .then(function () { gaTrack('native_file'); })
            .catch(function (err) {
              /* Pas de retry URL share : l'activation utilisateur a ete consommee par ce rejet,
                 le 2e appel a navigator.share echouerait avec "Must be handling a user gesture".
                 Fallback direct clipboard pour avoir au moins le lien copie + toast. */
              if (!isUserCancel(err)) copyToClipboard();
            });
        } catch (e) {
          copyToClipboard();
        }
        return;
      }
    }
    shareUrlOnly();
  }
  root.querySelectorAll('[data-sl-share]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var row = btn.closest('[data-sl-row]');
      if (row) shareRow(row);
    });
  });

  /* ---- URL params: ?gen= auto-select + ?range= filter + ?return= back button ---- */
  var IS_FR = (document.documentElement.lang || 'fr').toLowerCase().indexOf('fr') === 0;
  function detectReturnLabel(url) {
    var u = decodeURIComponent(url || '');
    if (u.indexOf('/products/') !== -1) return IS_FR ? 'Retour au produit' : 'Back to product';
    if (u.indexOf('configurateur') !== -1 || u.indexOf('configurator') !== -1) return IS_FR ? 'Continuer mon configurateur' : 'Continue my configurator';
    if (u.indexOf('/collections/') !== -1) return IS_FR ? 'Retour à la collection' : 'Back to collection';
    return IS_FR ? '← Retour' : '← Back';
  }
  try {
    var params = new URLSearchParams(window.location.search);
    var initGen = params.get('gen');
    if (initGen) {
      setTimeout(function () {
        var v = root.querySelector('[data-sl-vignette="' + initGen + '"]');
        if (v && !v.hidden) v.click();
      }, 60);
    }
    var initRange = params.get('range');
    if (initRange) {
      var rangeList = initRange.split(',');
      setTimeout(function () {
        rangeList.forEach(function (r) {
          var chip = root.querySelector('[data-sl-range-chip="' + r.trim() + '"]');
          if (chip && !chip.classList.contains('is-active')) chip.click();
        });
      }, 120);
    }
    var initClip = params.get('clip');
    if (initClip) {
      (function sendArrive(tries) { /* gtag arrive après ce script : réessai 10 s */
        if (typeof window.gtag === 'function') { window.gtag('event', 'sound_library_arrive_shared', { clip: initClip }); return; }
        if (tries > 0) setTimeout(function () { sendArrive(tries - 1); }, 250);
      })(40);
      setTimeout(function () {
        var clipRow = root.querySelector('[data-sl-row][data-handle="' + initClip + '"]');
        if (clipRow) {
          if (!currentGen) {
            var g = clipRow.dataset.gen;
            var vig = root.querySelector('[data-sl-vignette="' + g + '"]');
            if (vig && !vig.hidden) vig.click();
          }
          setTimeout(function () {
            clipRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
            /* Try autoplay; if browser blocks it, mark row as awaiting tap */
            var clipAudio = rowAudio(clipRow);
            if (!clipAudio) return;
            clipRow.classList.add('is-shared-clip');
            setTimeout(function () {
              pauseAllExcept(clipAudio);
              var p = clipAudio.play();
              if (p && p.catch) {
                p.then(function () {
                  clipRow.classList.remove('is-shared-clip');
                }).catch(function () {
                  /* Autoplay blocked - keep visual prompt active */
                  clipRow.classList.add('is-await-tap');
                  if (window.gtag) window.gtag('event', 'sound_library_autoplay_blocked', { clip: initClip });
                });
              }
            }, 500);
          }, 400);
        }
      }, 300);
    }
    var returnUrl = params.get('return');
    if (returnUrl) {
      var ret = document.querySelector('[data-sl-return]');
      if (ret) {
        ret.hidden = false;
        ret.href = decodeURIComponent(returnUrl);
        var labelEl = ret.querySelector('[data-sl-return-label]');
        if (labelEl) labelEl.textContent = detectReturnLabel(returnUrl);
      }
    }
  } catch (e) {}

  /* ---- Dynamic sticky top for bar variant (Shopify on-scroll-up header) ---- */
  if (root.classList.contains('is-sticky-bar')) {
    var header = document.querySelector('sticky-header')
              || document.querySelector('.header-wrapper')
              || document.querySelector('#shopify-section-header')
              || document.querySelector('header[role="banner"]');
    function updateStickyTop() {
      var topPx = 0;
      if (header) {
        var rect = header.getBoundingClientRect();
        topPx = Math.max(0, rect.bottom);
      }
      root.style.setProperty('--sl-sticky-top', topPx + 'px');
    }
    updateStickyTop();
    var rafSticky = null;
    function scheduleStickyUpdate() {
      if (rafSticky) return;
      rafSticky = requestAnimationFrame(function () {
        rafSticky = null;
        updateStickyTop();
      });
    }
    window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyUpdate);
  }
})();
